export enum ModalType {
    Warning,
    Question,
    Error,
    OK
}
